import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderSlot as _renderSlot, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "q-pb-sm"
}

import { computed, watch } from "vue";
import { DetailsPanelProps } from "@/types";
import { appStore, selectionStore } from "@/hooks";
import FlexBox from "@/components/common/display/content/FlexBox.vue";
import { IconButton } from "@/components";


/**
 * Controls the open state of a details right side panel.
 */
const __default__ = {
  name: "DetailsPanel",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    panel: { type: [Boolean, String] }
  },
  emits: ["open"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const open = computed(() => appStore.popups.detailsPanel === props.panel);

watch(
  () => open.value,
  (open) => {
    if (!open) return;

    emit("open");
  }
);

return (_ctx: any,_cache: any) => {
  return (open.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(FlexBox, {
          justify: "between",
          align: "center",
          b: "2"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(IconButton), {
              icon: "cancel",
              tooltip: "Close panel",
              "data-cy": "button-close-details",
              class: "float-left",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(selectionStore).clearSelections()))
            }),
            _createVNode(FlexBox, null, {
              default: _withCtx(() => [
                _renderSlot(_ctx.$slots, "actions")
              ]),
              _: 3
            })
          ]),
          _: 3
        }),
        _renderSlot(_ctx.$slots, "default")
      ]))
    : _createCommentVNode("", true)
}
}

})